import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logoimg from "../../../assets/images/Mountain-mystries-logo.png";
import { Link } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
import { showSuccessToast } from "../../../assets/toastUtils";
import ActivePropertySelectBox from "../../../CustomComponents/Property/ActivePropertySelectBox/ActivePropertySelectBox";
import LoginBtn from "../../../CustomComponents/Login/LoginBtn";
import CustomerDetailDropdown from "./CustomerDetailsDropdown";
import NewUIAccountDetailDropdown from "../../../CustomComponents/NewComponents/NewUILogin/NewUIAccountDetailsDropdown";
import { getContentScore } from "../../../utils/utils";
import logout from "../../../assets/new-images/logout.png";

function CustomerHeader({ showSelectProperty, vendorProperty }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loader, setLoader] = useState(false);
  const [hideToggle, setHideToggle] = useState(false);
  const [logOutPopup, setLogOutPopup] = useState(false);
  const navigate = useNavigate();
  const handleShowToggle = () => {
    setHideToggle(!hideToggle);
  };
  const [accountDetails, setAccountDetails] = useState(false);
  const handleOnClick = (e) => {
    e.preventDefault();
    setAccountDetails(!accountDetails);
  };
  const [loginDetails, setLoginDetails] = useState(false);
  const handleOnClickLogIn = (e) => {
    e.preventDefault();
    setLoginDetails(!loginDetails);
  };

  // console.log("isLoggedIn", isLoggedIn);
  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = async (e) => {
    e.preventDefault();

    navigate("/");
    localStorage.clear();
    showSuccessToast("Logged Out Successful");
  };
  const customButtonStyles = {
    fontSize: "12px",
    fontWeight: "500",
  };

  // useEffect(() => {
  //   const updateHideToggle = () => {
  //     if (window.innerWidth <= 640) {
  //       setHideToggle(false);
  //     } else {
  //       setHideToggle(true);
  //     }
  //   };

  //   updateHideToggle(); // Set the initial state based on screen size
  //   window.addEventListener("resize", updateHideToggle);

  //   return () => window.removeEventListener("resize", updateHideToggle);
  // }, []);

  const [customerData, setCustomerData] = useState([]);
  const [agentData, setAgentData] = useState([]);

  const [name, setName] = useState("");
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const storedUserDetails = localStorage.getItem("userDetails");
    if (storedUserDetails) {
      const userDetails = JSON.parse(storedUserDetails);
      // console.log(userDetails);
      setName(userDetails.name);
    }

    const storedUserType = localStorage.getItem("userType");
    if (storedUserType) {
      setUserType(storedUserType);
    }
  }, []);
  const closePriceDetails = (id) => {
    setHideToggle(false);
  };

  const { id } = useParams();
  // console.log(id);
  const [dropdown, setDropdown] = useState(false);

  const handleOpenDropdown = () => {
    setDropdown((prevState) => !prevState);
  };

  // const handleOutsideClick = (e) => {
  //   if (dropdown && !e.target.closest(".dropdown")) {
  //     setDropdown(false);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("click", handleOutsideClick);
  //   return () => {
  //     document.removeEventListener("click", handleOutsideClick);
  //   };
  // }, [dropdown]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    address: "",
    gst_information: "",
    company_information: "",
  });
  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const userToken = localStorage.getItem("token");

  const fetchCustomerDetails = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        // setAgentDetails(data?.data);
        localStorage.setItem("userDetails", JSON.stringify(data?.data));
        localStorage.setItem("role", "agent");

        setAddressData({
          country: data?.data?.country || "",
          state: data?.data?.state || "",
          city: data?.data?.city || "",
          address: data?.data?.address || "",
          latitude: data?.data?.latitude || "",
          longitude: data?.data?.longitude || "",
          placeId: data?.data?.placeId || "",
        });

        let additionalDetails;

        if (Array.isArray(data?.data?.additional_details)) {
          additionalDetails = {
            gst: data?.data?.additional_details[0]?.gst,
            company: data?.data?.additional_details[0]?.company,
          };
        } else {
          additionalDetails = {
            gst: data?.data?.additional_details?.gst,
            company: data?.data?.additional_details?.company,
          };
        }

        // console.log(additionalDetails, 'additionalDetails');

        setFormData((prev) => ({
          ...prev,
          company_name: data?.data?.name || "",
          name: data?.data?.name,
          phone: data?.data?.phone || "",
          email: data?.data?.email,
          country: data?.data?.country || "",
          state: data?.data?.state || "",
          city: data?.data?.city || "",
          address: data?.data?.address || "",
          gst_information: additionalDetails?.gst || "",
          company_information: additionalDetails?.company || "",

          zipcode: data?.data?.zipcode || "",
        }));

        if (data.success) {
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  };
  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === "customer") {
      fetchCustomerDetails();
    } else {
      fetchCustomerDetails();
    }
  }, []);

  const arrayToCheck = [
    "name",
    "email",
    "phone",
    "city",
    "state",
    "country",
    "address",
    "zipcode",
    "gst_information",
    "company_information",
  ];

  const score = getContentScore({
    formData: formData,
    arrayToCheck,
  });

  // console.log(formData);
  // console.log(arrayToCheck, 'arrayToCheck');

  return (
    <header style={{ borderRadius: "15px" }}>
      <button
        className="toggle_menu_icon agent_newtogglee_menu_icon"
        onClick={handleShowToggle}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="22"
          viewBox="0 0 30 22"
          fill="none"
          style={{ margin: "0" }}
        >
          <rect y="0.399902" width="30" height="1.2" fill="#333333"></rect>
          <rect y="10.3999" width="30" height="1.2" fill="#333333"></rect>
          <rect y="20.3999" width="30" height="1.2" fill="#333333"></rect>
        </svg>
      </button>
      {hideToggle && (
        <div className="fixed_bg_navbar">
          <div className="" id="vendorProperty">
            <div className="sidebar" id="sidebar">
              <div className="close_popup">
                <svg
                  onClick={() => setHideToggle(false)}
                  width="30"
                  height="30"
                  viewBox="0 0 14 13"
                  style={{ margin: "5px" }}
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 12.5L13 0.5" stroke="#000000" strokeWidth="1.2" />
                  <path d="M13 12.5L1 0.5" stroke="#000000" strokeWidth="1.2" />
                </svg>
              </div>

              <div style={{ padding: "10px" }}>
                <NavLink className="Header-icon" to="/" exact>
                  <img src={logoimg} alt="logo-image" className="logo" />
                </NavLink>
              </div>

              <small className="small_text">MENU</small>
              <NavLink
                className="sidebar_btn flex align_items_center flex_gap_5"
                to={`/customer-dashboard`}
              >
                <span className="active_bg_color"></span>
                <span className="sidebar_btn_icon_text">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <mask
                      id="mask0_6855_8514"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="21"
                    >
                      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6855_8514)">
                      <path
                        d="M4.42443 17.5833C4.00345 17.5833 3.64714 17.4375 3.35547 17.1458C3.0638 16.8542 2.91797 16.4978 2.91797 16.0769V4.92311C2.91797 4.50214 3.0638 4.14582 3.35547 3.85416C3.64714 3.56249 4.00345 3.41666 4.42443 3.41666H15.5782C15.9992 3.41666 16.3555 3.56249 16.6471 3.85416C16.9388 4.14582 17.0846 4.50214 17.0846 4.92311V16.0769C17.0846 16.4978 16.9388 16.8542 16.6471 17.1458C16.3555 17.4375 15.9992 17.5833 15.5782 17.5833H4.42443ZM4.42443 16.3333H9.3763V4.66666H4.42443C4.36026 4.66666 4.30151 4.69339 4.24818 4.74686C4.19471 4.8002 4.16797 4.85895 4.16797 4.92311V16.0769C4.16797 16.141 4.19471 16.1998 4.24818 16.2531C4.30151 16.3066 4.36026 16.3333 4.42443 16.3333ZM10.6263 16.3333H15.5782C15.6423 16.3333 15.7011 16.3066 15.7544 16.2531C15.8079 16.1998 15.8346 16.141 15.8346 16.0769V10.5H10.6263V16.3333ZM10.6263 9.24999H15.8346V4.92311C15.8346 4.85895 15.8079 4.8002 15.7544 4.74686C15.7011 4.69339 15.6423 4.66666 15.5782 4.66666H10.6263V9.24999Z"
                        fill="#888888"
                      />
                    </g>
                  </svg>
                  Dashboard
                </span>
              </NavLink>

              <NavLink
                className="sidebar_btn flex align_items_center  flex_gap_5"
                to={`/customer-booking`}
              >
                <span className="active_bg_color"></span>
                <span className="sidebar_btn_icon_text">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6964_8144"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="21"
                    >
                      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6964_8144)">
                      <path
                        d="M9.1263 13.6796L12.1905 10.6154C12.3144 10.4915 12.4637 10.4282 12.6384 10.4254C12.813 10.4228 12.9649 10.4861 13.0942 10.6154C13.2235 10.7447 13.2882 10.8954 13.2882 11.0673C13.2882 11.2392 13.2235 11.3899 13.0942 11.5192L9.65359 14.96C9.5029 15.1106 9.32714 15.1858 9.1263 15.1858C8.92547 15.1858 8.74971 15.1106 8.59901 14.96L6.90839 13.2692C6.7845 13.1453 6.72116 12.996 6.71839 12.8213C6.71575 12.6467 6.77908 12.4947 6.90839 12.3654C7.03769 12.2361 7.18832 12.1715 7.36026 12.1715C7.53221 12.1715 7.68283 12.2361 7.81214 12.3654L9.1263 13.6796ZM4.42443 18.4167C4.00345 18.4167 3.64714 18.2708 3.35547 17.9792C3.0638 17.6875 2.91797 17.3312 2.91797 16.9102V5.75647C2.91797 5.3355 3.0638 4.97918 3.35547 4.68751C3.64714 4.39585 4.00345 4.25001 4.42443 4.25001H5.57818V3.12814C5.57818 2.9455 5.63936 2.793 5.76172 2.67064C5.88408 2.54842 6.03658 2.4873 6.21922 2.4873C6.402 2.4873 6.5545 2.54842 6.67672 2.67064C6.79908 2.793 6.86026 2.9455 6.86026 3.12814V4.25001H13.1744V3.1123C13.1744 2.93494 13.2342 2.7864 13.3538 2.66668C13.4735 2.5471 13.6221 2.4873 13.7994 2.4873C13.9768 2.4873 14.1253 2.5471 14.2448 2.66668C14.3646 2.7864 14.4244 2.93494 14.4244 3.1123V4.25001H15.5782C15.9992 4.25001 16.3555 4.39585 16.6471 4.68751C16.9388 4.97918 17.0846 5.3355 17.0846 5.75647V16.9102C17.0846 17.3312 16.9388 17.6875 16.6471 17.9792C16.3555 18.2708 15.9992 18.4167 15.5782 18.4167H4.42443ZM4.42443 17.1667H15.5782C15.6423 17.1667 15.7011 17.1399 15.7544 17.0865C15.8079 17.0331 15.8346 16.9744 15.8346 16.9102V9.0898H4.16797V16.9102C4.16797 16.9744 4.19471 17.0331 4.24818 17.0865C4.30151 17.1399 4.36026 17.1667 4.42443 17.1667ZM4.16797 7.8398H15.8346V5.75647C15.8346 5.6923 15.8079 5.63355 15.7544 5.58022C15.7011 5.52675 15.6423 5.50001 15.5782 5.50001H4.42443C4.36026 5.50001 4.30151 5.52675 4.24818 5.58022C4.19471 5.63355 4.16797 5.6923 4.16797 5.75647V7.8398Z"
                        fill="#888888"
                      />
                    </g>
                  </svg>
                  Bookings
                </span>
              </NavLink>

              <small className="small_text">GENERAL</small>
              <NavLink
                className="sidebar_btn flex align_items_center flex_gap_5"
                to={`/customer-profile`}
              >
                <span className="active_bg_color"></span>
                <span className="sidebar_btn_icon_text">
                  {" "}
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_6855_7787"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="21"
                    >
                      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6855_7787)">
                      <path
                        d="M9.07565 18.4166C8.79148 18.4166 8.54607 18.3223 8.3394 18.1337C8.13259 17.9452 8.00676 17.7131 7.9619 17.4374L7.75836 15.878C7.53516 15.8033 7.30627 15.6987 7.07169 15.5641C6.83725 15.4294 6.62759 15.2851 6.44273 15.1314L4.99877 15.7451C4.73697 15.8605 4.47391 15.8717 4.20961 15.7787C3.94516 15.6858 3.73975 15.517 3.59336 15.2724L2.65419 13.6441C2.5078 13.3995 2.46565 13.1407 2.52773 12.8676C2.58968 12.5947 2.73176 12.3696 2.95398 12.1922L4.20232 11.2547C4.18315 11.1308 4.16954 11.0064 4.16148 10.8814C4.15343 10.7564 4.1494 10.6319 4.1494 10.5078C4.1494 10.3894 4.15343 10.2689 4.16148 10.1466C4.16954 10.0242 4.18315 9.89041 4.20232 9.74513L2.95398 8.80763C2.73176 8.63027 2.591 8.40374 2.53169 8.12804C2.47239 7.85249 2.51593 7.59235 2.66232 7.34763L3.59336 5.74346C3.73975 5.50415 3.94516 5.33672 4.20961 5.24117C4.47391 5.14547 4.73697 5.15534 4.99877 5.27075L6.43461 5.87659C6.63558 5.71742 6.85009 5.57186 7.07815 5.43992C7.30621 5.30797 7.5303 5.20193 7.75044 5.12179L7.9619 3.56242C8.00676 3.28672 8.13259 3.05464 8.3394 2.86617C8.54607 2.67756 8.79148 2.58325 9.07565 2.58325H10.9219C11.2061 2.58325 11.4515 2.67756 11.6581 2.86617C11.865 3.05464 11.9908 3.28672 12.0356 3.56242L12.2392 5.12971C12.4892 5.22054 12.7154 5.32659 12.9177 5.44784C13.1202 5.56909 13.3246 5.712 13.5309 5.87659L15.0069 5.27075C15.2686 5.15534 15.5316 5.14547 15.7961 5.24117C16.0605 5.33672 16.2659 5.50415 16.4121 5.74346L17.3434 7.35575C17.4897 7.60034 17.5319 7.85915 17.4698 8.13221C17.4079 8.40513 17.2658 8.63027 17.0436 8.80763L15.7631 9.76909C15.793 9.90367 15.8093 10.0295 15.8121 10.1466C15.8147 10.2635 15.8161 10.3813 15.8161 10.4999C15.8161 10.6131 15.8134 10.7283 15.8079 10.8453C15.8027 10.9623 15.7835 11.0961 15.7504 11.2468L17.0067 12.1922C17.2289 12.3696 17.3724 12.5947 17.4371 12.8676C17.5017 13.1407 17.4608 13.3995 17.3144 13.6441L16.3704 15.2643C16.2242 15.509 16.0175 15.6778 15.7504 15.7708C15.4834 15.8637 15.2189 15.8524 14.9571 15.737L13.5309 15.1233C13.3246 15.2878 13.1141 15.4334 12.8994 15.5599C12.6847 15.6866 12.4646 15.79 12.2392 15.8701L12.0356 17.4374C11.9908 17.7131 11.865 17.9452 11.6581 18.1337C11.4515 18.3223 11.2061 18.4166 10.9219 18.4166H9.07565ZM9.16544 17.1666H10.8034L11.1029 14.9343C11.5282 14.8232 11.9168 14.6653 12.2688 14.4608C12.6209 14.256 12.9604 13.9929 13.2873 13.6714L15.3577 14.5416L16.1784 13.1249L14.3706 11.7628C14.4401 11.547 14.4873 11.3354 14.5123 11.128C14.5375 10.9208 14.55 10.7114 14.55 10.4999C14.55 10.283 14.5375 10.0736 14.5123 9.87179C14.4873 9.66985 14.4401 9.4636 14.3706 9.25304L16.1942 7.87492L15.3738 6.45825L13.2792 7.34117C13.0003 7.04311 12.6662 6.77978 12.2769 6.55117C11.8875 6.32256 11.4935 6.16068 11.095 6.06554L10.8321 3.83325H9.17836L8.90252 6.05763C8.47739 6.15804 8.08482 6.31186 7.72482 6.51908C7.36468 6.72645 7.02114 6.99353 6.69419 7.32034L4.62377 6.45825L3.80336 7.87492L5.60294 9.21617C5.5335 9.41395 5.48489 9.61964 5.45711 9.83325C5.42933 10.0469 5.41544 10.2717 5.41544 10.5078C5.41544 10.7248 5.42933 10.9374 5.45711 11.1458C5.48489 11.3541 5.53086 11.5598 5.59502 11.7628L3.80336 13.1249L4.62377 14.5416L6.68627 13.6666C7.00252 13.9913 7.34065 14.2573 7.70065 14.4647C8.06079 14.6719 8.45877 14.8311 8.89461 14.9422L9.16544 17.1666ZM10.0084 12.9999C10.7017 12.9999 11.2917 12.7566 11.7784 12.2699C12.265 11.7833 12.5084 11.1933 12.5084 10.4999C12.5084 9.80659 12.265 9.21658 11.7784 8.72992C11.2917 8.24325 10.7017 7.99992 10.0084 7.99992C9.30641 7.99992 8.71426 8.24325 8.2319 8.72992C7.74954 9.21658 7.50836 9.80659 7.50836 10.4999C7.50836 11.1933 7.74954 11.7833 8.2319 12.2699C8.71426 12.7566 9.30641 12.9999 10.0084 12.9999Z"
                        fill="#888888"
                      />
                    </g>
                  </svg>
                  Settings
                </span>
              </NavLink>

              <Link
                className="sidebar_btn flex align_items_center flex_gap_5"
                onClick={() => setLogOutPopup(true)}
              >
                <span className="active_bg_color"></span>
                <span className="sidebar_btn_icon_text">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <mask
                      id="mask0_6855_7727"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="21"
                    >
                      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6855_7727)">
                      <path
                        d="M10.6182 17.5834C10.441 17.5834 10.2925 17.5236 10.1728 17.4038C10.0532 17.2842 9.99339 17.1358 9.99339 16.9584C9.99339 16.7811 10.0532 16.6326 10.1728 16.513C10.2925 16.3933 10.441 16.3334 10.6182 16.3334H15.5782C15.6423 16.3334 15.7011 16.3067 15.7544 16.2532C15.8079 16.1999 15.8346 16.1411 15.8346 16.077V4.92321C15.8346 4.85904 15.8079 4.80029 15.7544 4.74696C15.7011 4.69348 15.6423 4.66675 15.5782 4.66675H10.6182C10.441 4.66675 10.2925 4.60689 10.1728 4.48716C10.0532 4.36758 9.99339 4.21911 9.99339 4.04175C9.99339 3.86439 10.0532 3.71591 10.1728 3.59633C10.2925 3.47661 10.441 3.41675 10.6182 3.41675H15.5782C15.9992 3.41675 16.3555 3.56258 16.6471 3.85425C16.9388 4.14591 17.0846 4.50223 17.0846 4.92321V16.077C17.0846 16.4979 16.9388 16.8542 16.6471 17.1459C16.3555 17.4376 15.9992 17.5834 15.5782 17.5834H10.6182ZM10.0269 11.1251H3.54297C3.36561 11.1251 3.21714 11.0652 3.09755 10.9455C2.97783 10.8259 2.91797 10.6774 2.91797 10.5001C2.91797 10.3227 2.97783 10.1742 3.09755 10.0547C3.21714 9.93494 3.36561 9.87508 3.54297 9.87508H10.0269L8.42443 8.27258C8.30901 8.15717 8.24998 8.0164 8.24734 7.85029C8.24471 7.68418 8.30373 7.53647 8.42443 7.40716C8.54512 7.27786 8.69151 7.21105 8.86359 7.20675C9.03554 7.20258 9.18616 7.26508 9.31547 7.39425L11.894 9.97279C12.0446 10.1235 12.1198 10.2992 12.1198 10.5001C12.1198 10.7009 12.0446 10.8767 11.894 11.0274L9.31547 13.6059C9.19158 13.7298 9.04443 13.7909 8.87401 13.7892C8.70359 13.7877 8.55373 13.7223 8.42443 13.593C8.30373 13.4637 8.24554 13.3152 8.24984 13.1476C8.25401 12.9798 8.31651 12.8356 8.43734 12.7149L10.0269 11.1251Z"
                        fill="#888888"
                      />
                    </g>
                  </svg>
                  Logout
                </span>
              </Link>
            </div>
          </div>
        </div>
      )}

      {!vendorProperty ? (
        <div style={{ padding: "10px" }}>
          <div className="flex justify_content_between align_items_center">
            <div
              className="w-half Header-main flex align_items_center"
              style={{ gap: "20px" }}
            >
              {/* <div style={{ width: "65px" }}>
                <NavLink className="Header-icon" to="/" exact>
                  <img src={logoimg} alt="logo-image" className="logo" />
                </NavLink>
              </div> */}

              <section className="profile_sec">
                <svg
                  className="profile_spinner"
                  width="50"
                  height="50"
                  viewBox="0 0 60 60"
                >
                  <circle
                    cx="30"
                    cy="30"
                    r="20"
                    stroke="#ddd"
                    strokeWidth="5"
                    fill="transparent"
                  />
                  <circle
                    cx="30"
                    cy="30"
                    r="20"
                    stroke="#009A50"
                    strokeWidth="5"
                    fill="transparent"
                    strokeLinecap="round"
                    strokeDasharray="125.6"
                    strokeDashoffset={125.6 - (125.6 * score) / 100}
                    transform="rotate(0 30 30)"
                  />
                </svg>
                <div>
                  <span>Profile Score</span>
                  <h6>
                    {Math.floor(Number(score))} <span>/ 100</span>
                  </h6>
                </div>
              </section>
            </div>

            {/* <Link to={"/"} className="visit-website" target="_blank">
                Visit Website
              </Link> */}
            {isLoggedIn && (
              <CustomerDetailDropdown
                name={name}
                userType={userType}
                // handleLogout={handleLogout}
              />
            )}

            {/* <div className="support_btn cursor_pointer">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_2485_129"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="17"
                  >
                    <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_2485_129)">
                    <path
                      d="M8 15.8335V14.5002H12.6667V13.8335H10V8.50016H12.6667V7.8335C12.6667 6.54461 12.2111 5.44461 11.3 4.5335C10.3889 3.62239 9.28889 3.16683 8 3.16683C6.71111 3.16683 5.61111 3.62239 4.7 4.5335C3.78889 5.44461 3.33333 6.54461 3.33333 7.8335V8.50016H6V13.8335H3.33333C2.96667 13.8335 2.65278 13.7029 2.39167 13.4418C2.13056 13.1807 2 12.8668 2 12.5002V7.8335C2 7.01127 2.15833 6.23627 2.475 5.5085C2.79167 4.78072 3.22222 4.14461 3.76667 3.60016C4.31111 3.05572 4.94722 2.62516 5.675 2.3085C6.40278 1.99183 7.17778 1.8335 8 1.8335C8.82222 1.8335 9.59722 1.99183 10.325 2.3085C11.0528 2.62516 11.6889 3.05572 12.2333 3.60016C12.7778 4.14461 13.2083 4.78072 13.525 5.5085C13.8417 6.23627 14 7.01127 14 7.8335V14.5002C14 14.8668 13.8694 15.1807 13.6083 15.4418C13.3472 15.7029 13.0333 15.8335 12.6667 15.8335H8ZM3.33333 12.5002H4.66667V9.8335H3.33333V12.5002ZM11.3333 12.5002H12.6667V9.8335H11.3333V12.5002Z"
                      fill="#333333"
                    />
                  </g>
                </svg>
                Support
                <div className="supportDetails">
                  <Link className="flex" to="tel:+919805021966">
                    <span className="supportSvg">
                      <svg
                        className="m_0"
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="#FFFFFF"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2263_992"
                          style={{
                            maskType: "alpha",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "18",
                            height: "19",
                          }}
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2263_992)">
                          <path
                            d="M14.9625 16.25C13.4 16.25 11.8563 15.9094 10.3313 15.2281C8.80625 14.5469 7.41875 13.5813 6.16875 12.3313C4.91875 11.0813 3.95312 9.69375 3.27188 8.16875C2.59063 6.64375 2.25 5.1 2.25 3.5375C2.25 3.3125 2.325 3.125 2.475 2.975C2.625 2.825 2.8125 2.75 3.0375 2.75H6.075C6.25 2.75 6.40625 2.80937 6.54375 2.92812C6.68125 3.04688 6.7625 3.1875 6.7875 3.35L7.275 5.975C7.3 6.175 7.29375 6.34375 7.25625 6.48125C7.21875 6.61875 7.15 6.7375 7.05 6.8375L5.23125 8.675C5.48125 9.1375 5.77812 9.58437 6.12187 10.0156C6.46562 10.4469 6.84375 10.8625 7.25625 11.2625C7.64375 11.65 8.05 12.0094 8.475 12.3406C8.9 12.6719 9.35 12.975 9.825 13.25L11.5875 11.4875C11.7 11.375 11.8469 11.2906 12.0281 11.2344C12.2094 11.1781 12.3875 11.1625 12.5625 11.1875L15.15 11.7125C15.325 11.7625 15.4688 11.8531 15.5812 11.9844C15.6937 12.1156 15.75 12.2625 15.75 12.425V15.4625C15.75 15.6875 15.675 15.875 15.525 16.025C15.375 16.175 15.1875 16.25 14.9625 16.25ZM4.51875 7.25L5.75625 6.0125L5.4375 4.25H3.76875C3.83125 4.7625 3.91875 5.26875 4.03125 5.76875C4.14375 6.26875 4.30625 6.7625 4.51875 7.25ZM11.2313 13.9625C11.7188 14.175 12.2156 14.3438 12.7219 14.4688C13.2281 14.5938 13.7375 14.675 14.25 14.7125V13.0625L12.4875 12.7063L11.2313 13.9625Z"
                            fill="#000"
                          />
                        </g>
                      </svg>
                    </span>
                    <span>
                      <b style={{ fontSize: "12px" }}>Call Support</b>
                      <br />
                      <span style={{ color: "#016937" }}>+91-98050-21966</span>
                    </span>
                  </Link>
                  <Link className="flex" to="mailto:info@mountainmysteries.com">
                    <span className="supportSvg">
                      <svg
                        className="m_0"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2263_999"
                          style={{
                            maskType: "alpha",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "18",
                            height: "19",
                          }}
                        >
                          <rect
                            x="0.333374"
                            y="0.5"
                            width="18"
                            height="18"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_2263_999)">
                          <path
                            d="M3.33337 15.5C2.92087 15.5 2.56775 15.3531 2.274 15.0594C1.98025 14.7656 1.83337 14.4125 1.83337 14V5C1.83337 4.5875 1.98025 4.23438 2.274 3.94063C2.56775 3.64688 2.92087 3.5 3.33337 3.5H15.3334C15.7459 3.5 16.099 3.64688 16.3927 3.94063C16.6865 4.23438 16.8334 4.5875 16.8334 5V14C16.8334 14.4125 16.6865 14.7656 16.3927 15.0594C16.099 15.3531 15.7459 15.5 15.3334 15.5H3.33337ZM9.33337 10.25L3.33337 6.5V14H15.3334V6.5L9.33337 10.25ZM9.33337 8.75L15.3334 5H3.33337L9.33337 8.75ZM3.33337 6.5V5V14V6.5Z"
                            fill="#000"
                          />
                        </g>
                      </svg>
                    </span>
                    <span>
                      <b style={{ fontSize: "12px" }}>Mail Support</b>
                      <br />
                      <span style={{ color: "#016937" }}>
                        {" "}
                        info@mountainmysteries.com
                      </span>
                    </span>
                  </Link>
                </div>
              </div> */}
          </div>
        </div>
      ) : (
        // </div>
        <div style={{ padding: "0 10px" }}>
          <div className="flex_align_center justify_content_between HeaderMain-content">
            <div
              className="w-half Header-main flex align_items_center"
              style={{ gap: "20px" }}
            >
              <Link className="visit-website" to={"/"} target="_blank">
                Visit Website
              </Link>
              <div style={{ width: "65px" }}>
                <NavLink
                  className="Header-icon"
                  to="/vendor/property/list"
                  exact
                >
                  <img src={logoimg} alt="logo-image" className="logo" />
                </NavLink>
              </div>

              <div className="support_btn cursor_pointer">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_2485_129"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="17"
                  >
                    <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_2485_129)">
                    <path
                      d="M8 15.8335V14.5002H12.6667V13.8335H10V8.50016H12.6667V7.8335C12.6667 6.54461 12.2111 5.44461 11.3 4.5335C10.3889 3.62239 9.28889 3.16683 8 3.16683C6.71111 3.16683 5.61111 3.62239 4.7 4.5335C3.78889 5.44461 3.33333 6.54461 3.33333 7.8335V8.50016H6V13.8335H3.33333C2.96667 13.8335 2.65278 13.7029 2.39167 13.4418C2.13056 13.1807 2 12.8668 2 12.5002V7.8335C2 7.01127 2.15833 6.23627 2.475 5.5085C2.79167 4.78072 3.22222 4.14461 3.76667 3.60016C4.31111 3.05572 4.94722 2.62516 5.675 2.3085C6.40278 1.99183 7.17778 1.8335 8 1.8335C8.82222 1.8335 9.59722 1.99183 10.325 2.3085C11.0528 2.62516 11.6889 3.05572 12.2333 3.60016C12.7778 4.14461 13.2083 4.78072 13.525 5.5085C13.8417 6.23627 14 7.01127 14 7.8335V14.5002C14 14.8668 13.8694 15.1807 13.6083 15.4418C13.3472 15.7029 13.0333 15.8335 12.6667 15.8335H8ZM3.33333 12.5002H4.66667V9.8335H3.33333V12.5002ZM11.3333 12.5002H12.6667V9.8335H11.3333V12.5002Z"
                      fill="#333333"
                    />
                  </g>
                </svg>
                Support
                <div className="supportDetails" id="support-detail">
                  <Link className="flex" to="tel:+919805021966">
                    <span className="supportSvg">
                      <svg
                        className="m_0"
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="#FFFFFF"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2263_992"
                          style={{
                            maskType: "alpha",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "18",
                            height: "19",
                          }}
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2263_992)">
                          <path
                            d="M14.9625 16.25C13.4 16.25 11.8563 15.9094 10.3313 15.2281C8.80625 14.5469 7.41875 13.5813 6.16875 12.3313C4.91875 11.0813 3.95312 9.69375 3.27188 8.16875C2.59063 6.64375 2.25 5.1 2.25 3.5375C2.25 3.3125 2.325 3.125 2.475 2.975C2.625 2.825 2.8125 2.75 3.0375 2.75H6.075C6.25 2.75 6.40625 2.80937 6.54375 2.92812C6.68125 3.04688 6.7625 3.1875 6.7875 3.35L7.275 5.975C7.3 6.175 7.29375 6.34375 7.25625 6.48125C7.21875 6.61875 7.15 6.7375 7.05 6.8375L5.23125 8.675C5.48125 9.1375 5.77812 9.58437 6.12187 10.0156C6.46562 10.4469 6.84375 10.8625 7.25625 11.2625C7.64375 11.65 8.05 12.0094 8.475 12.3406C8.9 12.6719 9.35 12.975 9.825 13.25L11.5875 11.4875C11.7 11.375 11.8469 11.2906 12.0281 11.2344C12.2094 11.1781 12.3875 11.1625 12.5625 11.1875L15.15 11.7125C15.325 11.7625 15.4688 11.8531 15.5812 11.9844C15.6937 12.1156 15.75 12.2625 15.75 12.425V15.4625C15.75 15.6875 15.675 15.875 15.525 16.025C15.375 16.175 15.1875 16.25 14.9625 16.25ZM4.51875 7.25L5.75625 6.0125L5.4375 4.25H3.76875C3.83125 4.7625 3.91875 5.26875 4.03125 5.76875C4.14375 6.26875 4.30625 6.7625 4.51875 7.25ZM11.2313 13.9625C11.7188 14.175 12.2156 14.3438 12.7219 14.4688C13.2281 14.5938 13.7375 14.675 14.25 14.7125V13.0625L12.4875 12.7063L11.2313 13.9625Z"
                            fill="#000"
                          />
                        </g>
                      </svg>
                    </span>
                    <span>
                      <b style={{ fontSize: "12px" }}>Call Support</b>
                      <br />
                      <span style={{ color: "#016937" }}>+91-98050-21966</span>
                    </span>
                  </Link>
                  <Link className="flex" to="mailto:info@mountainmysteries.com">
                    <span className="supportSvg">
                      <svg
                        className="m_0"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2263_999"
                          style={{
                            maskType: "alpha",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "18",
                            height: "19",
                          }}
                        >
                          <rect
                            x="0.333374"
                            y="0.5"
                            width="18"
                            height="18"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_2263_999)">
                          <path
                            d="M3.33337 15.5C2.92087 15.5 2.56775 15.3531 2.274 15.0594C1.98025 14.7656 1.83337 14.4125 1.83337 14V5C1.83337 4.5875 1.98025 4.23438 2.274 3.94063C2.56775 3.64688 2.92087 3.5 3.33337 3.5H15.3334C15.7459 3.5 16.099 3.64688 16.3927 3.94063C16.6865 4.23438 16.8334 4.5875 16.8334 5V14C16.8334 14.4125 16.6865 14.7656 16.3927 15.0594C16.099 15.3531 15.7459 15.5 15.3334 15.5H3.33337ZM9.33337 10.25L3.33337 6.5V14H15.3334V6.5L9.33337 10.25ZM9.33337 8.75L15.3334 5H3.33337L9.33337 8.75ZM3.33337 6.5V5V14V6.5Z"
                            fill="#000"
                          />
                        </g>
                      </svg>
                    </span>
                    <span>
                      <b style={{ fontSize: "12px" }}>Mail Support</b>
                      <br />
                      <span style={{ color: "#016937" }}>
                        {" "}
                        info@mountainmysteries.com
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {logOutPopup && (
        <div className="bg_back_drop_overlay">
          <div className="bg-white-div p_0">
            <div style={{ height: "150px" }}>
              {" "}
              <img src={logout} alt="logout image" />
            </div>
            <div className="p_15">
              {" "}
              <h4>Confirm Logout</h4>
              <span className="block mt-5">
                Are you sure you want to logout ?
              </span>
              <div className="mt-10 flex align_items_center flex_gap_5">
                <button
                  className="w-half no_logout_btn"
                  onClick={() => setLogOutPopup(false)}
                >
                  No
                </button>
                <button
                  className="w-half vendor_common_property"
                  onClick={handleLogout}
                >
                  Yes
                </button>
              </div>{" "}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default CustomerHeader;
